<template>
  <font-awesome-icon
    icon="times"
    size="lg"
    class="icon"
    @click.stop="remove()"/>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  props: {
    entry: {
      required: true,
      type: Object
    }
  },

  mixins: [
    MixinResultHandler
  ],

  methods: {
    remove: async function () {
      const message = this.$store.getters['entry/removeMessage'](this.entry)
      if (window.confirm(message)) {
        const result = await this.$store.dispatch('entry/cancel', this.entry)
        this.showSnack(result)
        this.$store.dispatch('entry/retrieveEntries', this.$route.params.id)
      }
    }
  }
}
</script>
